import { loadLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'
import { getObjectUtil } from 'packages/src'
import getEndpointSectionUtil from 'modules/section/utils/get-endpoint/index.js'

/**
 * Loads the comments of the given instance.
 * @param  {Instance} instance
 * @returns {Function}
 */
export default function loadInstanceCommentsSectionAction (instance) {
  return (dispatch, getState) => {
    const path = getPathReduxUtil(instance)
    const instanceKey = 'comments'
    dispatch(
      loadLegacyReduxAction({
        endpoint: getEndpointSectionUtil(instance) + '/comments',
        path,
        instanceKey
      })
    )

    // If the instance is not loading,
    // it means the `load` didn't trigger
    instance = getObjectUtil(getState(), path)
    if (!isLoadingReduxUtil(instance)) {
      return
    }

    // Used to know the comments are loading
    dispatch(
      updateLegacyReduxAction({
        path,
        key: instanceKey,
        value: null,
        isLocal: true
      })
    )
  }
}
